const question = {
    waitForRaising: { values: ['E', 'D'] },
    agreeForLittleLoss: { values: ['E', 'P'] },
    worryOnBiggestLoss: { values: ['E'] },
};

export default question;
